import colors from '@rategravity/frontend/theme/colors';
import React from 'react';
import Dashboard from '../dashboard';
import Agent from './agent';
import './complete.css';

const style = {
  container: {
    textAlign: 'center',
    color: colors.primary,
    padding: '2em'
  }
};

const CompleteContainer = ({
  advisor,
  children,
  action,
  scenario,
  purpose,
  actionPipe,
  state,
  hideAdvisor,
  ...props
}) => {
  if (!advisor) {
    advisor = state === 'PA' ? 'tyler' : state === 'FL' ? 'oscar' : 'mike';
  }
  return (
    <Dashboard {...props} hasBumper={false}>
      <div style={style.container} className="complete__container">
        <div className="complete__action">{action}</div>
        {hideAdvisor ? null : (
          <div className="complete__advisor">
            <Agent advisor={advisor} bgColor="beige" />
          </div>
        )}
      </div>
      {children}
    </Dashboard>
  );
};

export default CompleteContainer;



// WEBPACK FOOTER //
// ./src/components/complete/index.js